export const BACKEND_ENDPOINT = "https://api.score.idjshow.com/"

// Authentication URLS
export const ACCESS_TOKEN_URL = BACKEND_ENDPOINT + "token/";
export const REFRESH_TOKEN_URL = BACKEND_ENDPOINT + "token/refresh/";

// Vote URL
export const VOTES_URL = BACKEND_ENDPOINT + "votes/";
export const GET_ARTIST_VOTE_CARD = VOTES_URL + "artist/";
export const SUBMIT_ARTIST_VOTE = VOTES_URL + "submit/";
export const CHANGE_VOTE_LIVE_STATUS_URL = VOTES_URL + "active/";
export const RESET_VOTES_URL = VOTES_URL + "reset/";